import { Node, mergeAttributes } from '@tiptap/core';

export const TemplateVariable = Node.create({
  name: 'templateVariable',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      name: {
        default: null,
        parseHTML: el => el.getAttribute('data-name'),
        renderHTML: attrs => ({ 'data-name': attrs.name }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-type="template-variable"]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'template-variable',
        'data-name': node.attrs.name,
        class: 'variable-chip',
        contenteditable: 'false',
      }),
      `{{${node.attrs.name}}}`,
    ];
  },

  addCommands() {
    return {
      insertVariable:
        name =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs: { name } }),
    };
  },
});
